import React, { useEffect, useState } from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const GridLines = () => {
    const [showGridLines, setShowGridLines] = useState(true);

    const storageKey = 'bva:grid-lines';

    const toggleGridlines = setShowGridLines.bind(null, (cV) => {
        localStorage.setItem(storageKey, String(!cV));
        return !cV;
    });

    useEffect(() => {
        window.toggleGridlines = toggleGridlines;

        const inStorage = localStorage.getItem(storageKey);

        if (inStorage) {
            setShowGridLines(inStorage === 'true');
        }

        const toggleGridWithKeys = (event) => {
            // CTRL + Shift + 4
            if (
                (event.ctrlKey && event.shiftKey && Number(event.key) === 4)
                || (event.ctrlKey && event.shiftKey && event.key === '$')
            ) {
                toggleGridlines();
            }
        };

        window.addEventListener('keydown',toggleGridWithKeys);

        return () => {
            window.removeEventListener('keydown', toggleGridWithKeys);
        };
    }, []);

    if (!showGridLines) {
        return null;
    }

    return (
        <div
            className='fixed w-full indent-0 pointer-events-none overflow-hidden'
            style={{
                zIndex: '9999'
            }}>
            <div className='layout-container h-screen'>
                <div className='flex flex-wrap layout-negative-margin h-full'>
                    {Array(12).fill(null).map((_, i) => {
                        return (
                            <div
                                className='w-1/12 layout-item-padding'
                                key={i}>
                                <div
                                    className='h-full'
                                    style={{
                                        borderColor: '#076cef78',
                                        backgroundColor: '#076cef03',
                                        borderStyle: 'solid',
                                        borderTopWidth: '0',
                                        borderBottomWidth: '0',
                                        borderLeftWidth: '1px',
                                        borderRightWidth: '1px',
                                    }}>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default GridLines;
